<!--
    描述：岗位新增
    日期：2021/04/28
    作者：zwh
-->
<template>
    <div>
        <el-form :model="objectForm" :rules="formRules" ref="objectForm" label-width="100px">
            <el-row v-if="objectForm.parentId != 0">
                <el-col :span="24">
                    <el-form-item label="上级岗位" prop="" :show-message="false">
                        <el-input v-model="objectForm.parentName" autocomplete="off" disabled :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="岗位名称" prop="sname" :show-message="false">
                        <el-input v-model="objectForm.sname" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="权限范围" prop="" :show-message="false">
                        <el-select v-model="objectForm.dataScope"
                                   placeholder=""
                                   size="small"
                                   clearable>
                            <el-option v-for="item in authScopeSelectList"
                                       :key="item.id"
                                       :label="item.sname"
                                       :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import { getDictByParentValue} from 'api/system/sys.js'
import { saveOrUpdate } from 'api/system/sysPosition.js'
export default {
    name : '',
    props : {
        mode: {
            type: String,
            default: 'add'
        },
        transObj: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    components: {

    },
    data() {
        return {
            //权限选择下拉信息
            authScopeSelectList : [],

            objectForm: {
                id : '',
                parentId : '',  //父角色id
                parentName : '',//父角色名称
                sname: '',   //角色名称
                dataScope : '',

                remark : '',
            },
            formRules: {
                sname: [{required: true, message: '请输入...', trigger: 'blur'}],
                dataScope: [{required: true, message: '请选择...', trigger: 'change'}],
            },
        }
    },
    mounted() {},
    computed: {
        // 是否可编辑
        isDisabled() {
            return this.mode === 'view' ? true : false
        }
    },
    watch: {},
    created() {
        this.getAuthScopeDict()

        //赋值
        this.objectForm.id = this.transObj.id
        this.objectForm.parentId = this.transObj.parentId
        this.objectForm.parentName = this.transObj.parentName
        //编辑/修改/查看等
        if(this.objectForm.id != '') this.getObjectById()
    },
    methods: {
        //点击确定按钮事件
        doSave() {
            let that = this
            this.$refs['objectForm'].validate((valid) => {
                if (valid) {
                    let param = this.objectForm
                    saveOrUpdate(param).then(res => {
                        if(res.operationCode==1){
                            if(res.msg=='faild') {
                                that.$message({message: res.data,type: 'error'});
                                return
                            }
                            that.$message({message: '保存成功',type: 'success'});
                            //刷新
                            that.$emit('handle-success')
                        }
                    });

                } else {
                    return false;
                }
            });
        },
        getObjectById(){

        },
        // 获取数据权限 范围码表
        getAuthScopeDict() {
            let that = this
            let param = { value: 1004 }
            getDictByParentValue(param).then(res => {
                if (res.operationCode == 1) {
                    that.authScopeSelectList = res.data
                }
            })
        },
    }
}
</script>
<style lang="less">

</style>